import { Serializable } from '@/models/core/serializable';

export class StatsNetwork implements Serializable<StatsNetwork> {
  categories: StatsNetworkCategories[] = [];
  links: StatsNetworkLinks[] = [];
  nodes: StatsNetworkNodes[] = [];

  deserialize(input: any): StatsNetwork {
    this.categories = input.categories.map((category: StatsNetworkCategories) => new StatsNetworkCategories().deserialize(category));
    this.links = input.links.map((link: StatsNetworkLinks) => new StatsNetworkLinks().deserialize(link));
    this.nodes = input.nodes.map((node: StatsNetworkNodes) => new StatsNetworkNodes().deserialize(node));
    return this;
  }
}

export class StatsNetworkCategories implements Serializable<StatsNetworkCategories> {
  name: string;

  deserialize(input: any): StatsNetworkCategories {
    this.name = input.name;
    return this;
  }
}

export class StatsNetworkLinks implements Serializable<StatsNetworkLinks> {
  source: string;
  target: string;

  deserialize(input: any): StatsNetworkLinks {
    this.source = input.source;
    this.target = input.target;
    return this;
  }
}

export class StatsNetworkNodes implements Serializable<StatsNetworkNodes> {
  category: string;
  name: string;
  symbolSize: number;

  deserialize(input: any): StatsNetworkNodes {
    this.category = input.category;
    this.name = input.name;
    this.symbolSize = input.symbolSize;
    return this;
  }
}
